import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { projectsAPI } from '../services/api';
import './ProjectList.css';

function ProjectList() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await projectsAPI.getAll();
      setProjects(response.data.data);
      setError(null);
    } catch (err) {
      setError('Failed to fetch projects');
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      try {
        await projectsAPI.delete(id);
        fetchProjects();
      } catch (err) {
        alert('Failed to delete project');
        console.error('Error deleting project:', err);
      }
    }
  };

  if (loading) return <div className="loading">Loading projects...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="project-list-container">
      <div className="header-section">
        <h2>Projects</h2>
        <Link to="/projects/new" className="btn btn-primary">
          + New Project
        </Link>
      </div>

      {projects.length === 0 ? (
        <div className="empty-state">
          <p>No projects found</p>
          <Link to="/projects/new" className="btn btn-primary">
            Create Your First Project
          </Link>
        </div>
      ) : (
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.project_id} className="project-card">
              <div className="project-header">
                <h3>{project.project_name}</h3>
                <span className="project-code">{project.project_code}</span>
              </div>
              <div className="project-info">
                <p>
                  <strong>Location:</strong> {project.location}
                </p>
                <p className="project-date">
                  Created: {new Date(project.created_at).toLocaleDateString()}
                </p>
              </div>
              <div className="project-actions">
                <Link
                  to={`/projects/${project.project_id}/visits/new`}
                  className="btn btn-sm btn-success"
                >
                  New Site Visit
                </Link>
                <Link
                  to={`/projects/${project.project_id}/edit`}
                  className="btn btn-sm btn-secondary"
                >
                  Edit
                </Link>
                <button
                  onClick={() => handleDelete(project.project_id)}
                  className="btn btn-sm btn-danger"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectList;
